module.exports = __webpack_public_path__ + "img/map.7683c954.png";